import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

export const getLeaderboardLiveRankingNoteStyles = (theme: Theme) =>
  StyleSheet.create({
    banner: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 7,
      marginTop: 10,
      marginLeft: 12,
      marginRight: 18,
      paddingVertical: 8,
      paddingHorizontal: 10,
      borderRadius: 10,
      backgroundColor: theme.background.inset,
    },
    text: {
      flex: 1,
      fontSize: 12,
      fontWeight: '600',
      color: theme.gray[600],
      lineHeight: 16,
    },
  });
